import { cleanV2StateSelector } from "./cleanV2StateSelector";
import { RootState } from "../../../store";

export const cleanV2DetailsSelector = (state: RootState) =>
  cleanV2StateSelector(state).details;
